<template>
  <div class="side-navigation min-h-screen">
    <div class="w-full h-full flex flex-row justify-start relative">
      <div class="sections flex flex-col justify-start">
        <div @click="setMenu('Dashboard', '/dashboard/overview')" :class="{active: currentMenu === 'Dashboard', 'non-active': currentMenu !== 'Dashboard'}"  class="menu-category flex flex-col justify-center">
          <i class="fas fa-tachometer-alt text-3xl mr-2 text-center"></i>
          <span class="text-center">Dashboard</span>
        </div>
        <div @click="setMenu('Ecommerce', '/ecommerce/inventory/products')" :class="{active: currentMenu === 'Ecommerce', 'non-active': currentMenu !== 'Ecommerce'}" class="menu-category flex flex-col justify-center">
          <i class="el-icon-shopping-cart-1 text-3xl mr-2 text-center"></i>
          <span class="text-center">Ecommerce</span>
        </div>
        <div @click="setMenu('Customer', '/customer/merchant-files-upload')" :class="{active: currentMenu === 'Customer', 'non-active': currentMenu !== 'Customer'}" class="menu-category flex flex-col justify-center">
          <i class="fas fa-users-cog text-3xl mr-2 text-center"></i>
          <span class="text-center">Customer AI</span>
        </div>
        <div @click="setMenu('Geospatial', '/geospatial/sale-analysis')" :class="{active: currentMenu === 'Geospatial', 'non-active': currentMenu !== 'Geospatial'}" class="menu-category flex flex-col justify-center">
          <i class="fas fa-map-marked-alt text-3xl mr-2 text-center"></i>
          <span class="text-center">Geospatial</span>
        </div>
        <div @click="setMenu('Recommendation', '/recommendation/kpi')" :class="{active: currentMenu === 'Recommendation', 'non-active': currentMenu !== 'Recommendation'}" class="menu-category flex flex-col justify-center">
          <i class="fas fa-thumbs-up text-3xl mr-2 text-center"></i>
          <span class="text-center">Recomme- <br> ndation</span>
        </div>
        <div @click="setMenu('Prediction')" :class="{active: currentMenu === 'Prediction', 'non-active': currentMenu !== 'Prediction'}" class="menu-category flex flex-col justify-center">
          <i class="fas fa-chart-line text-3xl mr-2 text-center"></i>
          <span class="text-center">Sales Prediction</span>
        </div>
      </div>
      <div class="sections-menus h-full">
        <div class="current-section"><p class="text-center uppercase text-white">{{currentMenu}}</p></div>
        <el-menu
          :router="true"
          :default-active="'/'"
          :unique-opened="true"
          class="el-menu-vertical-demo min-h-screen">
          <span v-for="menu in getMenu">
            <el-submenu v-if="menu.microMenu" :index="menu.key" :class="{'el-sub-menu-item-bg__active': $route.path.includes(menu.key.toLowerCase())}">
              <template class="sub-menu-header" slot="title">
                <span slot="title" class="sub-menu-title">{{menu.key}}</span>
              </template>
              <el-menu-item v-for="subMenu in menu.microMenu" :index="subMenu.url"  :class="{'el-menu-item-bg__active': $route.path === subMenu.url}">
                <span class="cursor-pointer">{{subMenu.key}}</span>
                <el-tag class="float-right" :type="'warning'" size="mini" v-if="subMenu.url === '#' && !subMenu.microMenu">comming soon</el-tag>
              </el-menu-item>
            </el-submenu>
            <el-menu-item v-if="!menu.microMenu && menu.url !== '#'" :index="menu.url" :class="{'el-menu-item-bg__active': $route.path === menu.url}">
              <span class="cursor-pointer">{{menu.key}}</span>
              <el-tag class="float-right" :type="'warning'" size="mini" v-if="menu.url === '#' && !menu.microMenu">comming soon</el-tag>
            </el-menu-item>
          </span>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
import Constants from '../../Constants';

export default {
  name: 'SideNavigation',
  data() {
    return {
      currentMenu: 'Dashboard',
      menu: { ...Constants },
    };
  },
  computed: {
    getMenu() {
      return this.menu.subMenu[this.currentMenu];
    },
  },
  methods: {
    setMenu(menu, link) {
      this.currentMenu = menu;
      this.$router.push(link);
    },
  },
  mounted() {
    if (this.$route.path.includes('dashboard')) {
      this.currentMenu = 'Dashboard';
    }

    if (this.$route.path.includes('ecommerce')) {
      this.currentMenu = 'Ecommerce';
    }

    if (this.$route.path.includes('customer')) {
      this.currentMenu = 'Customer';
    }

    if (this.$route.path.includes('geospatial')) {
      this.currentMenu = 'Geospatial';
    }

    if (this.$route.path.includes('recommendation')) {
      this.currentMenu = 'Recommendation';
    }
  },
};
</script>

<style scoped lang="scss">
  .side-navigation {
    display: none;

    @media (min-width: 900px) {
      display: block;
      flex: 0 1 23%;
    }

    .sections {
      flex: 0 1 30%;
      padding: 10px;

      .non-active {
        background-color: #fff;
        color: #838383;

        i {
          color: #838383;
        }
      }

      .active {
        background-color: #363741;
        color: #fff;

        i {
          color: #fff;
        }
      }
      .menu-category {
        margin-left: 12px;
        padding: 5px;
        border: 1px solid #838383;
        border-radius: 5px;
        font-size: 8px;
        width: 70px;
        height: 70px;
        margin-bottom: 20px;
        cursor: pointer;
      }
    }

    .sections-menus {
      flex: 0 1 68%;

      .current-section {
        background-color: #363741;
        height: 30px;
        font-size: 10px;
        padding-top: 0.5rem;
        letter-spacing: 10px
      }

      .el-menu-vertical-demo {
        background-color: #363741;
      }
    }
  }

  .el-menu {
    border: 0;
  }

  .el-menu-item {
    color: #A4A6B4 !important;
  }
  .el-menu-item:hover {
    background: #3F404A !important;
  }

  .settings .el-menu--inline {
    display: block !important;
  }

  .el-menu-item-bg__active {
    background: #3F404A !important;
    border-left: 5px solid #A4A6B4;
  }

  .el-sub-menu-item-bg__active {
    background: #3F404A !important;
    border-left: 5px solid #363741;
  }

  .el-submenu:hover {
    background: none !important;
  }

  .el-submenu__title:hover{
    background-color: green !important;
  }

  .sub-menu-title {
    color: #A4A6B4 !important;
  }

  .sub-menu-header {
    &:hover {
      background-color: #3F404A !important;
    }
  }

  .el-tag--warning {
    margin-top: 20px;
    font-size: 8px !important;
  }

</style>
